<template>
        <div class="" style="width: 100%;">
          <div class="task-modal-info" v-if="selectedTask && selectedTask.id">
            <div class="row">
              <div class="col text-center pt-3 pb-3" v-if="currentView != 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.task_assignees') }}</strong>
                </div>

                <span v-if="selectedTask.users && selectedTask.users.length">
                  <span class="mr-1 text-normal" v-for="(user, user_index) in getReducedUsers(selectedTask.users)"
                    :key="user_index">
                    <span qid="profile-photo">
                      <Avatar :object="user" size="xs"></Avatar>
                    </span>
                  </span>
                </span>
                <span v-if="selectedTask.users && selectedTask.users.length && selectedTask.users.length > 3"
                  class="badge cursor-pointer" @click="openUsersModal(selectedTask)">
                  <font-awesome-icon icon="users" />
                  + {{ selectedTask.users.length - 3 }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView == 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.task_assignees') }}</strong>
                </div>
                <span v-if="selectedTask.data_users && selectedTask.data_users.length">
                  <span class="mr-1 text-normal" v-for="(user, user_index) in getReducedUsers(selectedTask.data_users)"
                    :key="user_index">
                    <span qid="profile-photo">
                      <Avatar :object="user" size="xs"></Avatar>
                    </span>
                  </span>
                </span>
                <span
                  v-if="selectedTask.data_users && selectedTask.data_users.length && selectedTask.data_users.length > 3"
                  class="badge cursor-pointer" @click="openUsersModal(selectedTask)">
                  <font-awesome-icon icon="users" />
                  + {{ selectedTask.data_users.length - 3 }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.due_date') }}</strong>
                </div>
                <span class="text-normal" v-if="currentView != 'data_collection'">
                  <span v-if="getDifference(selectedTask.project.end_date) > 3">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span
                    v-if="getDifference(selectedTask.project.end_date) <= 3 && getDifference(selectedTask.project.end_date) >= 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.end_date) < 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-12" />
                    {{ Math.abs(getDifference(selectedTask.project.end_date)) }}
                    {{ $t('system.days') }}
                    {{ $t('system.overdue') }}
                  </span>
                </span>
                <span class="text-normal" v-if="currentView == 'data_collection'">
                  <span v-if="getDifference(selectedTask.project.data_collection_end_date) > 3">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.data_collection_end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span
                    v-if="getDifference(selectedTask.project.data_collection_end_date) <= 3 && getDifference(selectedTask.project.data_collection_end_date) >= 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.data_collection_end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.data_collection_end_date) < 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-12" />
                    {{ Math.abs(getDifference(selectedTask.project.data_collection_end_date)) }}
                    {{ $t('system.days') }}
                    {{ $t('system.overdue') }}
                  </span>
                  <span v-if="!selectedTask.project.data_collection_end_date">
                    {{ $t('system.n_a') }}
                  </span>
                </span>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView != 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('system.task_status') }}</strong>
                </div>
                <span v-if="selectedTask.status === 'completed'">
                  <span class="text-normal" v-if="selectedTask.sign_off_count > 0">
                    <font-awesome-icon v-if="signOffReached" icon="check-circle" class="icon-success" />
                    <font-awesome-icon v-else icon="exclamation-triangle" class="sign-off-pending" />
                  </span>
                  <span class="text-normal" v-else-if="selectedTask.qa_status === 'rejected'">
                    <font-awesome-icon icon="times-circle" class="icon-danger" />
                  </span>
                  <span class="text-normal" v-else>
                    <font-awesome-icon icon="check-circle" class="icon-success" />
                  </span>

                </span>
                <span v-if="selectedTask.status === 'pending'" class="pr-1">
                  <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                </span>
                <span class="text-normal"
                  v-if="selectedTask.status === 'completed' && selectedTask.sign_off_count > 0">
                  {{ $t('system.signed_off') }} ({{ signOffProgress }})
                </span>
                <span class="text-normal"
                  v-else-if="selectedTask.status === 'completed' && selectedTask.qa_status === 'rejected'">
                  {{ $t('system.rejected') }}
                </span>
                <span class="text-normal" v-else>
                  {{ $t('system.' + $options.filters.slugify(selectedTask.status)) }}
                </span>
                <div v-if="selectedTask.status === 'completed' && selectedTask.signers && selectedTask.signers.length"
                  class="mt-2 text-normal" qid="task-modal-signers">
                  <div v-for="signer in selectedTask.signers" :key="signer.user_id">
                    {{ signer.name }} – {{ signer.signed_at | formatDateTime }}
                  </div>
                </div>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView == 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('tasks.table.data_collection_status') }}</strong>
                </div>
                <span v-if="selectedTask.data_status && selectedTask.data_status === 'completed'">
                  <font-awesome-icon icon="check-circle" class="icon-success" />
                </span>
                <span v-if="selectedTask.data_status && selectedTask.data_status === 'pending'" class="pr-1">
                  <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                </span>
                <span v-if="selectedTask.data_status">
                  {{ $t('system.' + $options.filters.slugify(selectedTask.data_status)) }}
                </span>
                <span v-if="!selectedTask.data_status">
                  <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                  {{ $t('system.pending') }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.project') }}</strong>
                </div>
                <span v-if="isOwner(selectedTask.project)" class="text-success breadcrumb-item cursor-pointer"
                  @click="navigateToProject(selectedTask)">
                  <font-awesome-icon icon="calendar-alt" class="mr-1" />
                  {{ selectedTask.project.title }}
                </span>
                <span v-if="!isOwner(selectedTask.project)" class="text-success breadcrumb-item"
                  style="pointer-events:none;">
                  <font-awesome-icon icon="calendar-alt" class="mr-1" />
                  {{ selectedTask.project.title }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.owners_label') }}</strong>
                </div>
                <span class="mr-1 text-normal" v-for="(user, user_index) in getReducedUsers(selectedTask.project.users)"
                  :key="user_index">
                  <span qid="profile-photo">
                    <Avatar :object="user" size="xs"></Avatar>
                  </span>
                </span>
                <span v-if="selectedTask.project.users.length > 3" class="badge cursor-pointer"
                  @click="openUsersModal(selectedTask.project)">
                  <font-awesome-icon icon="users" />
                  + {{ selectedTask.project.users.length - 3 }}
                </span>
              </div>
            </div>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
              </div>
              <div class="col-sm-6 text-right">

                <b-modal ref="qa-log" modal-class="task-modal">
                  <template #modal-header="{ close }">
                    <div class="" style="width: 100%;">
                      <span @click="hideQaLog" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0 ">
                        <font-awesome-icon icon="times" />
                      </span>
                      <h5 class="mb-1 text-center" qid="update-user-title">
                        {{ $t('system.quality_control_log') }}
                      </h5>
                    </div>
                  </template>
                  <div class="pt-3" qid="qa-log-modal-body">
                    <div class="qa-log-summary">
                      <div>
                        <div class="qa-log-summary__label">{{ $t('system.current_sign_offs') }}</div>
                        <div class="qa-log-summary__value">
                          <font-awesome-icon v-if="signOffReached" icon="check-circle" class="icon-success mr-1" />
                          <font-awesome-icon v-else-if="selectedTask.sign_off_count > 0" icon="exclamation-triangle" class="sign-off-pending mr-1" />
                          {{ signOffProgress }}
                        </div>
                      </div>
                      <div>
                        <div class="qa-log-summary__label">{{ $t('system.required_sign_offs') }}</div>
                        <div class="qa-log-summary__value">{{ requiredSignOffs }}</div>
                      </div>
                    </div>
                    <QaLogTimeline v-if="qaComments && qaComments.length" :entries="qaComments"></QaLogTimeline>
                    <div v-if="!loadingQaComments && qaComments && !qaComments.length" class="text-muted">
                      {{ $t('system.no_results') }}
                    </div>
                    <div v-if="loadingQaComments">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </div>
                  </div>
                  <template #modal-footer="{ close }">
                    <div class="" style="width: 100%;">
                      <div class="alert alert-menu-color color-secondary mb-0" role="alert">
                        <div class="text-right">
                          <b-button class="" variant="secondary" @click="hideQaLog" qid="edit-p-cancel-button">
                            {{ $t('system.close') }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-modal>

                <b-button class="ml-3 mt-2" variant="danger"
                  v-if="selectedTask.status == 'completed' && selectedTask.qa_status != 'rejected' && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                  @click="showReopenQaTask" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.reject_and_reopen') }}
                </b-button>
                <b-modal ref="reopen-qa-task" modal-class="task-modal">
                  <template #modal-header="{ close }">
                    <div class="" style="width: 100%;">
                      <span @click="hideReopenQaTask" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
                        <font-awesome-icon icon="times" />
                      </span>
                      <h5 class="mb-1 text-center" qid="update-user-title">
                        {{ $t('system.reject_and_reopen') }}
                      </h5>
                    </div>
                  </template>
                  <b-form @submit="reOpenQaTask" qid="create-framework-control-form">
                    <div class="form-container">
                      <b-form-group>
                        <label qid="create-framewor-control-pg-label">
                          {{ $t('system.rejection_comment') }}
                          <span class="text-red">*</span>
                        </label>
                      </b-form-group>
                      <b-form-textarea qid="create-q-data_collection-form-description" v-model="qa_comment" rows="6"
                        max-rows="6" required></b-form-textarea>
                    </div>
                  </b-form>
                  <template #modal-footer="{ close }">
                    <div class="" style="width: 100%;">
                      <div class="alert alert-menu-color color-secondary mb-0" role="alert">
                        <div class="text-right">
                          <b-button class="" variant="secondary" @click="hideReopenQaTask" qid="edit-p-cancel-button">
                            {{ $t('maintenance.measures.create.cancel') }}
                          </b-button>
                          <b-button class="ml-3" variant="danger" :disabled="buttonDisabled || qaCommentMissing" @click="reOpenQaTask()"
                            qid="edit-p-submit-button">
                            <span v-if="buttonDisabled" class="mr-1">
                              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                            </span>
                            {{ $t('system.reject_and_reopen') }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-modal>
                <b-modal ref="reopen-qa-task-complete" modal-class="task-modal">
                  <template #modal-header="{ close }">
                    <div class="" style="width: 100%;">
                      <span @click="hideReopenQaTask" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
                        <font-awesome-icon icon="times" />
                      </span>
                      <h5 class="mb-1 text-center" qid="update-user-title">
                        {{ $t('system.complete_rejected_task') }}
                      </h5>
                    </div>
                  </template>
                  <b-form @submit="reOpenQaTask" qid="create-framework-control-form">
                    <div class="form-container">
                      <b-form-group>
                        <label qid="create-framewor-control-pg-label">
                          {{ $t('system.completion_comment') }}
                          <span class="text-red">*</span>
                        </label>
                      </b-form-group>
                      <b-form-textarea qid="create-q-data_collection-form-description" v-model="qa_comment" rows="6"
                        max-rows="6" required></b-form-textarea>
                    </div>
                  </b-form>
                  <template #modal-footer="{ close }">
                    <div class="" style="width: 100%;">
                      <div class="alert alert-menu-color color-secondary mb-0" role="alert">
                        <div class="text-right">
                          <b-button class="" variant="secondary" @click="hideReopenQaTask" qid="edit-p-cancel-button">
                            {{ $t('maintenance.measures.create.cancel') }}
                          </b-button>
                          <b-button class="ml-3" variant="success" :disabled="buttonDisabled || qaCommentMissing"
                            @click="completeOpenQaTask()" qid="edit-p-submit-button">
                            <span v-if="buttonDisabled" class="mr-1">
                              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                            </span>
                            {{ $t('tasks.modal.complete') }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-modal>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status == 'completed' && !isCurrentSigner && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                  @click="acceptQaTask" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.accept_and_complete') }}
                </b-button>


                <!-- Control assessment: fields save individually, so only Close and Finalize task -->
                <template v-if="isControlAssessment">
                  <b-button class="ml-3 mt-2" variant="secondary"
                    v-if="selectedTask.status != 'completed' && currentView != 'data_collection'"
                    @click="closeTask()" :disabled="buttonDisabled" qid="task-modal-close-button">
                    {{ $t('system.close') }}
                  </b-button>
                  <span class="d-inline-block" v-b-tooltip.hover
                    :title="hasOpenTextFields ? $t('tasks.modal.finalize_task_text_fields_open') : ''"
                    v-if="selectedTask.status !== 'completed' && currentView !== 'data_collection'">
                    <b-button class="ml-3 mt-2" variant="success"
                      @click="selectedTask.qa_status == 'rejected' ? showReopenQaTaskComplete() : finalizeTask()"
                      :disabled="buttonDisabled || hasOpenTextFields"
                      :style="hasOpenTextFields ? 'pointer-events: none;' : ''"
                      qid="task-modal-finalize_task-button">
                      {{ $t('tasks.modal.finalize_task') }}
                    </b-button>
                  </span>
                </template>

                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="!isControlAssessment && selectedTask.status != 'completed' && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.save_without_complete') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success" @click="completeTask()" :disabled="buttonDisabled"
                  qid="task-modal-complete_task-button"
                  v-if="!isControlAssessment && selectedTask.qa_status != 'rejected' && selectedTask.status !== 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <b-button class="ml-3 mt-2" variant="success" @click="showReopenQaTaskComplete()"
                  :disabled="buttonDisabled" qid="task-modal-complete_task-button"
                  v-if="!isControlAssessment && selectedTask.qa_status == 'rejected' && selectedTask.status !== 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <!--<b-button class="ml-3 mt-2"-->
                <!--variant="secondary"-->
                <!--v-if="selectedTask.status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'"-->
                <!--@click="reOpenTask()"-->
                <!--:disabled="buttonDisabled"-->
                <!--qid="task-modal-cancel-button"-->
                <!--&gt;-->
                <!--{{ $t('tasks.modal.task_reopen_button') }}-->
                <!--</b-button>-->
                <!--<b-button class="ml-3 mt-2"-->
                <!--variant="success"-->
                <!--v-if="selectedTask.status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'"-->
                <!--@click="saveTask()"-->
                <!--:disabled="buttonDisabled"-->
                <!--qid="task-modal-save-button"-->
                <!--&gt;-->
                <!--{{ $t('system.save') }}-->
                <!--</b-button>-->


                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.status !== 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'"
                  @click="saveDataTask()" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.save_without_complete') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success" @click="completeDataTask()" :disabled="buttonDisabled"
                  qid="task-modal-complete_data_task-button"
                  v-if="selectedTask.data_status !== 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.data_status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'"
                  @click="reOpenDataTask()" :disabled="buttonDisabled" qid="task-modal-cancel-button">
                  {{ $t('tasks.modal.data_collection_reopen_button') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save-button">
                  {{ $t('system.save') }}
                </b-button>


                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.status != 'completed' && selectedTask.code == 'system_impact_assessment'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.save_without_complete') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status != 'completed' && selectedTask.code == 'system_impact_assessment'"
                  @click="completeSystemRiskTask()" :disabled="buttonDisabled"
                  qid="task-modal-complete_system_risk-button">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.status == 'completed' && selectedTask.code == 'system_impact_assessment'"
                  @click="reOpenTask()" :disabled="buttonDisabled" qid="task-modal-cancel-button">
                  {{ $t('tasks.modal.task_reopen_button') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status == 'completed' && selectedTask.code == 'system_impact_assessment'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save-button">
                  {{ $t('system.save') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
</template>

<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';
import Avatar from '@/components/Avatar.vue';
import QaLogTimeline from '@/components/tasks/QaLogTimeline.vue';

export default {
  name: 'AssessmentGlobalSingleTaskModalFooter',
  mixins: [assessmentSingleTaskProxy],
  components: {
    Avatar,
    QaLogTimeline
  }
};
</script>
